/**
 * @file automatically generated from MApp.Endpoints.ContentController
 */ 

import { MetadataClient } from '../metadataClient';
import { ICrsListItem, ICrs, IValidationResult, IStringObject, ICrsTransform, IBounds } from '../models';

export class ContentClient extends MetadataClient {

    public static getCrses(sridString: string) {
        return MetadataClient.ajax<ICrsListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/crs/filter/${encodeURIComponent(sridString)}`)
        );
    }

    public static getCrsesByName(sridString: string) {
        return MetadataClient.ajax<ICrsListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/crs/filterwithname/${encodeURIComponent(sridString)}`)
        );
    }

    public static getCrsesByNameWithoutProjected(sridString: string) {
        return MetadataClient.ajax<ICrsListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/crs/filterwithnamewithoutproj/${encodeURIComponent(sridString)}`)
        );
    }

    public static getCrs(srid: number) {
        return MetadataClient.ajax<ICrs>(
            new Request(MetadataClient.endpointsUrl + `api/v2/studio/content/crs/${srid}`)
        );
    }

    public static isValidProjectedCrs(srid: number) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/crs/isprojected/${srid}`)
        );
    }

    public static isValidCrs(srid: number) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/crs/isvalid?srid=${srid}`)
        );
    }

    public static isCustomCrsValid(srid: number) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/customcrs/isvalidsrid?srid=${srid}`)
        );
    }

    public static isCustomCrsNameValid(name: string) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/customcrs/isvalidname?name=${encodeURIComponent(name)}`)
        );
    }

    public static isCustomWktValid(wkt: IStringObject) {
        return MetadataClient.ajax<IValidationResult>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/customcrs/isvalidwkt`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(wkt)
			})
        );
    }

    public static saveCustomCrs(crs: ICrs) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/customcrs`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(crs)
			})
        );
    }

    public static updateCustomCrs(crs: ICrs) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/customcrs`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(crs)
			})
        );
    }

    public static deleteCustomCrs(srid: number) {
        return MetadataClient.ajax<any>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/customcrs/${srid}`, {
				method: 'DELETE'
			})
        );
    }

    public static getCustomCrs(srid: number) {
        return MetadataClient.ajax<ICrs>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/customcrs/${srid}`)
        );
    }

    public static getCustomCrses() {
        return MetadataClient.ajax<ICrsListItem[]>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/customcrs`)
        );
    }

    public static crsTransform(transform: ICrsTransform) {
        return MetadataClient.ajax<IBounds>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/crs/transform`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(transform)
			})
        );
    }

    public static crsTransformAndCheck(transform: ICrsTransform) {
        return MetadataClient.ajax<IBounds>(
            new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/crs/transformandcheck`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(transform)
			})
        );
    }
}
